import { format, parseISO } from "date-fns";

import { useGetConsultationReport, useGetPatient } from "~/providers/hooks";
import { getFullName, isConsultationCompleted } from "~/providers/utils";
import { NoteFeed } from "~/providers/utils/types/patientFeeds";
import { PdfDownloadLink } from "../shared/PdfDownloadLink";
import { NoteFeedExportDocument } from "./NoteFeedExportDocument";

export const NoteFeedExportDownloadLink = ({
  noteFeed,
}: {
  noteFeed: NoteFeed;
}) => {
  const { data: patient, isLoading: isPatientLoading } = useGetPatient(
    noteFeed.organization_patient.patient_id,
  );
  const consultation = patient?.consultation;
  const isConsultationReportEnabled = isConsultationCompleted(
    consultation?.status,
  );
  const { data: consultationReport, isLoading: isConsultationReportLoading } =
    useGetConsultationReport(consultation?.id, {
      enabled: isConsultationReportEnabled && !!consultation?.id,
    });

  if (isPatientLoading || !patient) return null;

  if (isConsultationReportEnabled && isConsultationReportLoading) return null;

  const patientName = getFullName(patient.name, patient.last_name);
  const createdAt = format(parseISO(noteFeed.created_at), `MM_d_yyyy`);

  return (
    <PdfDownloadLink
      document={
        <NoteFeedExportDocument
          patient={patient}
          noteFeed={noteFeed}
          basicPatientInformation={
            consultationReport?.basic_patient_information
          }
        />
      }
      fileName={`Progress Note - ${patientName} - ${createdAt}.pdf`}
      className="w-fit border-none bg-transparent p-0 text-primary-600 hover:bg-transparent focus:bg-transparent"
    />
  );
};
